export default __webpack_public_path__ + "static/media/vf-associate-child-to-parent.b5320d42.svg";